////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isUndefined, map, reduce } from 'lodash'
///////COMPONENTS///////
import Base64Images from '../Ui/Base64Images/Base64Images'
import { salesHistoryByCodesActionCreators, globalLoadingActionCreators } from '../../store/actions'
/////////ASSETS/////////
import noImage from '../../assets/icones/global/no-picture.svg'

/////////STYLED/////////
const Wrapper = styled.div`
	display: grid;
	grid-template-column: 1fr;
`
const TicketWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`
const TitleWrapper = styled.div`
	font-weight: bold;
	font-size: ${(props) => props.theme.font.fxxl};
	margin: 15px 0;
	color: ${(props) => props.theme.colors.tabText};
`
const LigneWrapper = styled.div`
	display: grid;
	grid-template-rows: 35px;
	grid-template-columns: repeat(2, 1fr);
	row-gap: 20px;
	column-gap: 25px;
	border-bottom: 1px solid ${(props) => props.theme.colors.body};
	align-items: center;
`
const LigneWrapperImg = styled.div`
	max-height auto;
	max-width:auto;
	display:flex;
	align-items:center;
	flex-direction:row;
	justify-content:space-around;
	border-bottom: 1px solid ${(props) => props.theme.colors.body};
`
const KeyWrapper = styled.div`
	grid-column: 1/2;
	color: ${(props) => props.theme.colors.tabText};
	text-align: right;
`
const ValueWrapper = styled.div`
	grid-column: 2/2;
	color: ${(props) => props.theme.colors.tabText};
	text-align: left;
`
const DataWrapper = styled.div`
	width: max-content;
	height: max-content;
	border: 1px solid ${(props) => props.theme.colors.tabText};
	padding-left: 1%;
	padding-right: 1%;
	padding-bottom: 1%;
`
const DataBottomWrapper = styled.div`
	width: 430px;
	height: max-content;
	font-size: ${(props) => (props.size ? `${props.size}px` : null)};
`
const Separator = styled.div`
	height: 50px;
	width: 95%;
	border-bottom: 1px solid ${(props) => props.theme.colors.tabText};
`
/////////STYLED/////////

const TicketCodes = () => {
	const { user, translations, salesHistoryByCodes } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			salesHistoryByCodes: state.salesHistoryByCodes,
			salesHistoryByCodesTicket: state.salesHistoryByCodes.data,
			userKioskPerimeter: state.user.identity.kioskSelected,
		}),
		shallowEqual
	)

	const actionsSalesHistoryByCodes = bindActionCreators(salesHistoryByCodesActionCreators, useDispatch())

	let salesOrderId = document.location.href.split('/')

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		actionsSalesHistoryByCodes.postDisplayTicket(
			{
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			salesOrderId[5]
		)
		globalLoadingActionCreators.startLoading()
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		!isUndefined(salesHistoryByCodes.data) && (
			<Wrapper>
				<TicketWrapper>
					<TitleWrapper>{!isUndefined(salesHistoryByCodes.data) && translations[salesHistoryByCodes.data.header]}</TitleWrapper>
					<DataWrapper>
						<LigneWrapperImg>
							{salesHistoryByCodes.data.urlImg.length > 0 ? (
								<Base64Images
									base64={!isUndefined(salesHistoryByCodes.data) && salesHistoryByCodes.data.urlImg}
									width="350"
									height="40"
								/>
							) : (
								<img style={{ height: 40, width: 40, margin: '10px 0' }} src={noImage} />
							)}
						</LigneWrapperImg>
						{!isUndefined(salesHistoryByCodes.data) &&
							map(salesHistoryByCodes.data.rows, (elem, _id) => (
								<LigneWrapper>
									<KeyWrapper>{translations[elem.title]} :</KeyWrapper>{' '}
									{/* <ValueWrapper>{elem.value.includes('_') ? translations[elem.value] : elem.value}</ValueWrapper> */}
									<ValueWrapper>{!isUndefined(translations[elem.value]) ? translations[elem.value] : elem.value}</ValueWrapper>
								</LigneWrapper>
							))}
					</DataWrapper>
					<DataBottomWrapper style={{ fontSize: 8 }}>{salesHistoryByCodes.data.printNumber}</DataBottomWrapper>
					<DataBottomWrapper style={{ fontSize: 8, lineHeight: 1.5 }}>{translations['page__tpeTicket__footer']}</DataBottomWrapper>
				</TicketWrapper>
			</Wrapper>
		)
	)
}

TicketCodes.propTypes = {}

TicketCodes.defaultPropTypes = {}

export default TicketCodes
